import { render, staticRenderFns } from "./one.vue?vue&type=template&id=8d2b35c8&scoped=true&"
import script from "./one.vue?vue&type=script&lang=js&"
export * from "./one.vue?vue&type=script&lang=js&"
import style0 from "./one.vue?vue&type=style&index=0&id=8d2b35c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2b35c8",
  null
  
)

export default component.exports